(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  var EXIT_MS = isMobile ? 550 : 800;

  // The theme has many independent entrance/reveal systems (velangi-animations.js's global
  // .velangi-animate pass, plus a separate hand-rolled IntersectionObserver + hidden-state
  // CSS in most section/template files, plus a CSS-animation-based hero on the homepage) —
  // each built in isolation, none aware of the page-transition curtain or of each other. Any
  // one of them can still be sitting at opacity:0 (or mid fade) when the curtain is told to
  // reveal. Rather than patching each site separately, every known system is registered here
  // once; settlePendingReveals() walks the registry generically and force-settles anything
  // still pending in the initial viewport, synchronously and with no transition, right before
  // the curtain fades — regardless of whether that system's own observer has already fired.
  // Elements below the initial viewport are left untouched and keep their normal behavior.
  //
  // Class-toggle systems: hidden state removed by adding the listed "done" class.
  //   .velangi-animate  -> .no-animation   (assets/velangi-animations.js, sitewide)
  //   .reveal           -> .in             (sections/advisor-consultation.liquid)
  //   .vgc-reveal       -> .in             (sections/velangi-contact.liquid)
  //   .vsx-r            -> .in             (sections/velangi-stone-index.liquid)
  //   .wyc-r            -> .is-in          (sections/advisor-consultation.liquid,
  //                                         templates/page.przygotowaniewyceny.liquid)
  //   .reg-r            -> .is-in          (templates/page.regulamin.liquid)
  //   .shp-r            -> .is-in          (templates/page.wysylka.liquid)
  //   .vg-phil-figure   -> .vg-in-view     (templates/page.o-nas.liquid)
  var REVEAL_CLASS_SYSTEMS = [
    { selector: '.velangi-animate', doneClass: 'no-animation' },
    { selector: '.reveal, .vgc-reveal, .vsx-r', doneClass: 'in' },
    { selector: '.wyc-r, .reg-r, .shp-r', doneClass: 'is-in' },
    { selector: '.vg-phil-figure', doneClass: 'vg-in-view' }
  ];

  // Attribute + parent-gated system: templates/index.liquid's "mb-projects" homepage section
  // gates [data-mbp-reveal] children behind a .is-in-view class on the section itself, with a
  // per-attribute stagger delay — settled directly via inline styles rather than a class add.
  var ATTR_REVEAL_SELECTOR = '[data-mbp-reveal]';
  var ATTR_REVEAL_GROUP_SELECTOR = '.mb-projects';
  var ATTR_REVEAL_GROUP_CLASS = 'is-in-view';

  // CSS `animation:`-based system (not a transition/class toggle): the homepage hero
  // (assets/velangi.css) uses fixed-delay `animation: fadeUp ... forwards` per element.
  // Killing the animation alone would drop the element back to its pre-animation opacity:0
  // base state, so the final values are set explicitly alongside animation:none.
  var ANIMATION_REVEAL_SELECTOR = '.mb-hero-eyebrow, .mb-hero-title, .mb-hero-sub, .mb-hero-cta, .mb-hero-scroll';

  function settlePendingReveals() {
    var vh = window.innerHeight;
    function inViewport(el) {
      var rect = el.getBoundingClientRect();
      return rect.top < vh && rect.bottom > 0;
    }

    REVEAL_CLASS_SYSTEMS.forEach(function (system) {
      document.querySelectorAll(system.selector).forEach(function (el) {
        if (!inViewport(el)) return;
        el.style.transition = 'none';
        el.classList.add(system.doneClass);
      });
    });

    document.querySelectorAll(ATTR_REVEAL_SELECTOR).forEach(function (el) {
      if (!inViewport(el)) return;
      el.style.transition = 'none';
      el.style.opacity = '1';
      el.style.transform = 'none';
      var group = el.closest(ATTR_REVEAL_GROUP_SELECTOR);
      if (group) group.classList.add(ATTR_REVEAL_GROUP_CLASS);
    });

    document.querySelectorAll(ANIMATION_REVEAL_SELECTOR).forEach(function (el) {
      if (!inViewport(el)) return;
      el.style.animation = 'none';
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  // Incoming reveal — the destination page (nav, background, content) renders completely
  // normally the entire time; nothing about it is individually hidden, faded, or gated (see
  // CSS: only html::before animates). The readiness chain is real, sequential browser
  // signals with nothing racing against them: window.load (the whole first paint's worth of
  // resources, including CSS background-images) → document.fonts.ready → two animation
  // frames so the settled state has actually been painted before the curtain is told to
  // fade. No competing timer runs in parallel, so nothing can resolve early and win.
  if (root.hasAttribute('data-vg-incoming')) {
    var pageLoaded = document.readyState === 'complete'
      ? Promise.resolve()
      : new Promise(function (resolve) { window.addEventListener('load', resolve, { once: true }); });
    var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();

    pageLoaded
      .then(function () { return fontsReady; })
      .then(function () {
        settlePendingReveals();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            root.removeAttribute('data-vg-incoming');
          });
        });
      });
  }

  function isExcluded(link, href) {
    if (!href) return true;
    if (link.target && link.target !== '' && link.target !== '_self') return true;
    if (link.hasAttribute('download')) return true;
    if (/^(mailto:|tel:|javascript:|#)/i.test(href)) return true;
    var url;
    try { url = new URL(href, window.location.href); } catch (e) { return true; }
    if (url.origin !== window.location.origin) return true;
    if (url.pathname === window.location.pathname && url.hash) return true;
    // Optional leading locale segment (e.g. "/en/") — routes.cart_url etc. are prefixed
    // on any non-default language, so a bare "/cart" match alone let this capture-phase
    // listener steal the click ahead of cart-drawer.liquid's own handler on those locales,
    // sending "/en/cart" through a full page-transition navigation instead of opening the
    // drawer in place.
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(cart|checkout|checkouts|account|admin)(\/|$)/i.test(url.pathname)) return true;
    return false;
  }

  var navigating = false;

  document.addEventListener('click', function (e) {
    if (navigating) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (isExcluded(link, href)) return;

    e.preventDefault();
    navigating = true;
    var targetHref = link.href;

    function go() {
      try { sessionStorage.setItem('vgTransition', '1'); } catch (err) {}
      window.location.href = targetHref;
    }

    // Navigate only once the curtain has actually finished covering the viewport
    // (transitionend on <html>, where the curtain lives). The fallback below is a circuit
    // breaker only (tab backgrounded, transitionend genuinely never fires) — buffered well
    // past the transition's own duration so it can never race ahead of the real event and
    // navigate while the curtain is still short of fully opaque.
    var fallback = setTimeout(go, EXIT_MS + 400);
    root.addEventListener('transitionend', function onEnd(ev) {
      if (ev.target !== root || ev.propertyName !== 'opacity') return;
      root.removeEventListener('transitionend', onEnd);
      clearTimeout(fallback);
      go();
    });

    root.setAttribute('data-vg-transition', '1');
  }, true);

  // bfcache restore (browser back/forward) can bring back a page mid-transition — reset so
  // it never renders stuck behind an opaque or half-faded curtain.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    navigating = false;
    root.removeAttribute('data-vg-transition');
    root.removeAttribute('data-vg-incoming');
  });
})();

// ---- PDP tweaks (2026-10-20) — product page only ----------------------------
// Lives here (not in templates/product.liquid) because this file is already
// loaded with `defer` on every page, so it runs after the PDP markup exists,
// and a 160KB template doesn't need a full rewrite for two small DOM tweaks.
// Separate IIFE from the transitions code above, so its reduced-motion early
// return never skips this. CSS half lives in
// assets/velangi-product-mobile-order-patch.css ("2026-10-20" block).
//   1. Kod produktu (#ppgSku) -> end of the "Specyfikacja" accordion panel.
//      The accordion always renders Wykończenia + Dostawa; Specyfikacja only
//      when the product has a description — so 3 items = first one is
//      Specyfikacja. No Specyfikacja -> .vg-sku-keep leaves it where it was.
//   2. Free-delivery line under "Dodaj do koszyka" is hidden below the
//      200 zł free-shipping threshold (Shopify: Profil ogólny, strefa PL).
(function () {
  var info = document.querySelector('.ppg-wrap .ppg-info');
  if (!info) return;

  var sku = document.getElementById('ppgSku');
  if (sku) {
    var accItems = info.querySelectorAll('#ppgAccordion [data-acc-item]');
    var specContent = accItems.length >= 3 ? accItems[0].querySelector('.ppg-accordion-content') : null;
    if (specContent) specContent.appendChild(sku);
    else sku.classList.add('vg-sku-keep');
  }

  var FREE_SHIPPING_MIN = 20000; // grosze = 200 zł
  var form = document.getElementById('ppgForm');
  var wishBtn = document.getElementById('ppgWishBtn');
  function checkFreeShipping() {
    if (!form || !wishBtn) return;
    var price = parseInt(wishBtn.dataset.productPrice, 10);
    form.classList.toggle('vg-no-free-ship', !isNaN(price) && price < FREE_SHIPPING_MIN);
  }
  checkFreeShipping();
  // variant switch rewrites data-product-price on #ppgWishBtn — re-check after it
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.ppg-variant-btn')) setTimeout(checkFreeShipping, 0);
  });
})();

// ---- Cart drawer express filter (2026-10-20, v7) ---------------------------
// Shopify's express-checkout component (inside [data-drawer-express] in
// snippets/cart-drawer.liquid) renders each enabled wallet in its own slot,
// partly inside shadow DOM.
// ONE wallet per browser —
//   - Safari / any WebKit browser with Apple Pay (window.ApplePaySession
//     exists — macOS Safari, every iPhone/iPad browser) -> Apple Pay only;
//   - everything else (Chrome, Edge, Firefox, Android) -> Google Pay only.
// Shop Pay / PayPal are hidden everywhere (they still work at checkout).
// Step 1 hides every non-kept wallet. Step 2 doesn't depend on the
// component's inner structure: it MEASURES where the kept button actually
// is, moves it (transform) to the top-left of the box, stretches it to the
// box's full width, sets the box height to exactly that button and clips the
// rest (the component keeps empty slots reserved for the hidden wallets).
// v7: zoom-aware. On desktop the theme scales <body> with CSS `zoom`
// (--vg-fluid-zoom, e.g. 0.75). getBoundingClientRect() returns ZOOMED
// (visual) px, but width/height/transform are applied in the element's own
// UNZOOMED px — v6 mixed the two, which on desktop Safari made Apple Pay
// too narrow and clipped its bottom. `scale` below = visual / local and
// every measured distance is divided by it before being applied.
// Transforms/width are reset before every measurement, so re-runs never
// accumulate; re-runs happen whenever the drawer swaps in fresh buttons, a
// few times after (wallets render asynchronously), on resize and when the
// drawer opens.
(function () {
  var HAS_APPLE_PAY = typeof window.ApplePaySession !== 'undefined';
  var KEEP_RE = HAS_APPLE_PAY ? /apple[\s_-]?pay/i : /google[\s_-]?pay|gpay/i;
  var GAP = 8; // local px between kept buttons (if ever more than one)
  var SKIP_TAGS = { SLOT: 1, STYLE: 1, SCRIPT: 1, TEMPLATE: 1, LINK: 1 };
  var box = document.querySelector('#vgDrawer [data-drawer-express]');
  if (!box) return;

  function parentOf(el) {
    if (el.assignedSlot) return el.assignedSlot;
    if (el.parentElement) return el.parentElement;
    var r = el.getRootNode && el.getRootNode();
    return r && r.host ? r.host : null;
  }
  function attrSig(el) {
    return (el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('data-testid') || '');
  }
  function walk(rootNode, fn) {
    var els = rootNode.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      fn(els[i]);
      if (els[i].shadowRoot) walk(els[i].shadowRoot, fn);
    }
  }
  function findKeep() {
    var byTag = [];
    walk(box, function (el) {
      var t = el.tagName.toLowerCase();
      if (t.indexOf('-') !== -1 && KEEP_RE.test(t)) byTag.push(el);
    });
    if (byTag.length) return byTag;
    var hits = [];
    walk(box, function (el) { if (KEEP_RE.test(attrSig(el))) hits.push(el); });
    var out = [];
    hits.forEach(function (el) {
      var cur = el;
      while (cur && cur !== box && cur.tagName.indexOf('-') === -1) cur = parentOf(cur);
      if (cur && cur !== box && out.indexOf(cur) === -1) out.push(cur);
    });
    return out;
  }
  function childrenOf(node) {
    var list = [];
    if (node.tagName === 'SLOT' && node.assignedElements) list = list.concat(node.assignedElements());
    list = list.concat(Array.prototype.slice.call(node.children || []));
    if (node.shadowRoot) list = list.concat(Array.prototype.slice.call(node.shadowRoot.children));
    return list;
  }

  // step 1: hide every non-kept wallet (and wrappers that don't lead to a kept one)
  function hideOthers(keep) {
    var keepSet = new Set(keep);
    var path = new Set();
    keep.forEach(function (el) {
      var cur = el;
      while (cur && cur !== box) { path.add(cur); cur = parentOf(cur); }
    });
    path.add(box);
    path.forEach(function (node) {
      if (keepSet.has(node)) return;
      childrenOf(node).forEach(function (child) {
        if (path.has(child) || SKIP_TAGS[child.tagName]) return;
        if (child.style.display !== 'none') child.style.setProperty('display', 'none', 'important');
      });
    });
  }

  // step 2: measure + move kept button(s) flush, full width; box height = exactly the buttons
  function align(keep) {
    keep.forEach(function (el) {
      el.style.removeProperty('transform');
      el.style.removeProperty('width');
      el.style.removeProperty('max-width');
    });
    box.style.removeProperty('height');
    var boxRect = box.getBoundingClientRect();
    var localW = box.clientWidth;
    if (!localW || !boxRect.width) return;
    var scale = boxRect.width / box.offsetWidth || 1; // visual px per local px (CSS zoom)
    var items = keep.map(function (el) { return { el: el, r: el.getBoundingClientRect() }; })
      .filter(function (it) { return it.r.height > 0; })
      .sort(function (a, b) { return a.r.top - b.r.top; });
    if (!items.length) return;
    var y = 0; // local px
    items.forEach(function (it) {
      // full width first (may change its own box), then measure again for the move
      it.el.style.setProperty('width', localW + 'px', 'important');
      it.el.style.setProperty('max-width', 'none', 'important');
      var r = it.el.getBoundingClientRect();
      var dx = Math.round((boxRect.left - r.left) / scale);
      var dy = Math.round((boxRect.top - r.top) / scale + y);
      if (dx || dy) it.el.style.setProperty('transform', 'translate(' + dx + 'px, ' + dy + 'px)', 'important');
      y += r.height / scale + GAP;
    });
    box.style.setProperty('height', Math.ceil(y - GAP) + 'px', 'important');
    box.style.setProperty('overflow', 'hidden', 'important');
  }

  function run() {
    var keep = findKeep();
    if (!keep.length) return;
    hideOthers(keep);
    align(keep);
  }

  var timers = [];
  function burst() {
    timers.forEach(clearTimeout);
    timers = [0, 150, 500, 1200, 2500, 5000].map(function (ms) { return setTimeout(run, ms); });
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      // ignore our own style writes; react to real content changes only
      for (var i = 0; i < muts.length; i++) { if (muts[i].type === 'childList') { burst(); return; } }
    }).observe(box, { childList: true, subtree: true });
  }
  window.addEventListener('resize', burst, { passive: true });
  var drawer = document.getElementById('vgDrawer');
  if (drawer && window.MutationObserver) {
    // drawer slides in with a transform; re-measure once it's open
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) burst();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  burst();
})();
